// extracted by mini-css-extract-plugin
export default {"container":"PxecC","table":"qAMye","statusCell":"kAhwV","accepted":"ItN4n","rejected":"ekoAW"};